import { styled } from '@linaria/react';
import clsx from 'clsx';
export const StyledLandingLayout = /*#__PURE__*/styled("div")({
  name: "StyledLandingLayout",
  class: "s1d5mrt4"
});
export const LandingLayout = ({
  children,
  ...props
}) => {
  return <StyledLandingLayout {...props} className={clsx('container', props.className || '')}>
			{children}
		</StyledLandingLayout>;
};

require("./LandingLayout.linaria.module.css!=!../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingLayout.tsx");